import { useEffect, useRef } from "react";
import { Accordion, ListGroup } from "react-bootstrap";
import { YaraRevisionInfo } from "../@types";
import YaraHistoryItem from "./YaraHistoryItem";

const HISTORY_ACCORDION = "history";
const CLOSED_ACCORDION = "closed";

interface IYaraHistoryPanel {
  selectedRuleId: number;
  onItemClick: (ruleId: number) => void;
  historyItems: YaraRevisionInfo[];
}

const executeScroll = (element: null | HTMLElement) => {
  element?.scrollIntoView();
};

const YaraHistoryPanel = ({
  selectedRuleId,
  historyItems,
  onItemClick
}: IYaraHistoryPanel) => {
  const selectedRef = useRef(null);
  useEffect(() => executeScroll(selectedRef.current), [selectedRuleId]);
  return (
    <div className="width-100-pc" style={{ marginTop: "10px" }}>
      <Accordion defaultActiveKey={CLOSED_ACCORDION}>
        <Accordion.Item eventKey={HISTORY_ACCORDION}>
          <Accordion.Header>History</Accordion.Header>
          <Accordion.Body className="yara-history-body">
            <ListGroup variant="flush">
              {historyItems?.map(item => (
                <ListGroup.Item
                  key={item.value}
                  ref={item.value === selectedRuleId ? selectedRef : null}
                >
                  <YaraHistoryItem
                    selectedRuleId={selectedRuleId}
                    item={item}
                    onClick={onItemClick}
                  />
                </ListGroup.Item>
              ))}
            </ListGroup>
          </Accordion.Body>
        </Accordion.Item>
      </Accordion>
    </div>
  );
};

export default YaraHistoryPanel;
